function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  id: "check-circle",
  d: "M16.581,8a8.581,8.581,0,1,0,8.581,8.581A8.581,8.581,0,0,0,16.581,8Zm0,1.661a6.92,6.92,0,1,1-6.92,6.92,6.916,6.916,0,0,1,6.92-6.92m4.851,4.507-.78-.786a.415.415,0,0,0-.587,0l-4.891,4.851-2.069-2.086a.415.415,0,0,0-.587,0l-.786.78a.415.415,0,0,0,0,.587l3.141,3.166a.415.415,0,0,0,.587,0l5.972-5.924A.415.415,0,0,0,21.432,14.168Z",
  transform: "translate(-8 -8)"
});

var SvgCircleCheck = function SvgCircleCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17.161,
    height: 17.161,
    viewBox: "0 0 17.161 17.161"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/CircleCheck.85031b4e.svg";
export { SvgCircleCheck as ReactComponent };